enum TileSize {
  SmallSquare = 'smallSquare',
  Small = 'small',
  Large = 'large',
}

export default TileSize;
